import styled, { css } from 'styled-components';
import { Colors } from '~/config/Colors';
import * as Popover from '@radix-ui/react-popover';

export const InputDateTime = styled.div`
  width: 100%;

  ${props =>
    props.disabled &&
    css`
      ${Label} {
        opacity: 0.3;
        cursor: not-allowed;
      }
    `}
`;

export const Label = styled.label`
  margin-bottom: 4px;

  color: ${Colors.text_Color_1};
  font-size: 0.75em;
  font-weight: 500;
  line-height: 10px;
`;

export const InputContainer = styled.div`
  position: relative;
`;

export const Input = styled.input`
  width: 100%;
  height: 36px;
  /* padding: 18px; */
  border: 1px solid rgb(255 255 255 / 0.15);
  border-radius: 8px;
  cursor: pointer;

  color: ${Colors.text_Color_1};
  font-size: 0.75em;
  font-weight: 300;
  padding-left: 18px;

  text-align: left;
  background: ${Colors.Input_Color_1};

  transition-timing-function: ease-in-out;
  transition-duration: 300ms;
  transition-property: border;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &::placeholder {
    color: ${Colors.text_Color_1};
  }

  &:hover {
    border: 1px solid rgb(255 255 255 / 0.25);
  }
  &:focus {
    outline: none;
    border: 1px solid rgb(255 255 255 / 0.25);
  }
`;

export const Error = styled.p`
  display: block;

  margin-top: 0.3rem;

  color: ${Colors.ftColor6};
  font-size: 0.7em;
  font-weight: 300;

  transition-timing-function: ease-in-out;
  transition-duration: 300ms;
  transition-property: opacity;
`;

export const PopoverContent = styled(Popover.Content)`
  background: ${Colors.Color2};
  border: 1px solid rgb(255 255 255 / 0.15);
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 10px 38px -10px rgba(22, 23, 24, 0.35), 0 10px 20px -15px rgba(22, 23, 24, 0.2);
  animation-duration: 400ms;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform, opacity;
  z-index: 1000;
  /* min-width: 280px; */
  max-width: 320px;

  &[data-state='open'] {
    animation-name: slideDownAndFade;
  }

  &[data-state='closed'] {
    animation-name: slideUpAndFade;
  }

  @keyframes slideDownAndFade {
    from {
      opacity: 0;
      transform: translateY(-2px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes slideUpAndFade {
    from {
      opacity: 1;
      transform: translateY(0);
    }
    to {
      opacity: 0;
      transform: translateY(-2px);
    }
  }
`;

export const TimeSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
  border-bottom: 1px solid rgb(255 255 255 / 0.1);
`;

export const TimeLabel = styled.label`
  color: ${Colors.text_Color_1};
  font-size: 0.8em;
  font-weight: 500;
`;

export const TimeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TimeInput = styled.input`
  width: 60px;
  height: 32px;
  padding: 6px 8px;
  border: 1px solid rgb(255 255 255 / 0.15);
  border-radius: 4px;
  text-align: center;

  color: ${Colors.text_Color_1};
  font-size: 0.7em;
  font-weight: 300;

  background: ${Colors.Input_Color_1};

  &:focus {
    outline: none;
    border: 1px solid ${Colors.Color4};
  }

  /* Remove arrows from number input */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type='number'] {
    appearance: textfield;
    -moz-appearance: textfield;
  }
`;

export const TimeSeparator = styled.span`
  color: ${Colors.text_Color_1};
  font-size: 0.8em;
  font-weight: 500;
`;

export const CalendarSection = styled.div`
  margin-bottom: 12px;

  .rdp-root {
    --rdp-accent-color: ${Colors.Color4};
    --rdp-accent-background-color: ${Colors.Color4};
    --rdp-today-color: ${Colors.Color4};
    --rdp-day-height: 36px;
    --rdp-day-width: 36px;
    --rdp-day_button-height: 36px;
    --rdp-day_button-width: 36px;
    /* --rdp-disabled-opacity: 0.5; */
    --rdp-outside-opacity: 0.5;
    --rdp-nav_button-height: 28px;
    --rdp-nav_button-width: 28px;
    --rdp-months-gap: 0px;
    --rdp-weekday-padding: 4px;
  }

  .rdp-day {
    color: ${Colors.text_Color_1};
    background: transparent;
    font-size: 0.7em;
    font-weight: 300;
  }

  .rdp-today {
    color: ${Colors.Color4};
    font-weight: 500;
  }

  .rdp-outside {
    opacity: 0.3;
  }

  .rdp-dropdown_root {
    option {
      color: ${Colors.text_Color_1};
      opacity: 0.9;
    }
  }

  .rdp-weekday {
    color: ${Colors.Color6};
    font-weight: 500;
    font-size: 0.65em;
    text-align: center;
    opacity: 0.8;
  }

  .rdp-day_button:disabled {
    color: ${Colors.Color6};
    cursor: not-allowed;
    opacity: 0.1;
  }

  .rdp-dropdown {
    appearance: none;
    background: ${Colors.Input_Color_1};
    /* border: 1px solid rgba(255, 255, 255, 0.15); */
    border-radius: 4px;
    color: ${Colors.text_Color_1};
    font-size: 0.7em;
    padding: 4px 8px;
    cursor: pointer;
  }

  .rdp-dropdown_root {
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${Colors.text_Color_1};
  }
`;

export const ButtonSection = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding-top: 12px;
  border-top: 1px solid rgb(255 255 255 / 0.1);
`;

export const Button = styled.button`
  padding: 4px 8px;
  border: none;
  border-radius: 4px;
  font-size: 0.65em;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;

  ${props =>
    props.variant === 'cancel'
      ? css`
          background: transparent;
          color: ${Colors.text_Color_1};
          border: 1px solid rgb(255 255 255 / 0.15);

          &:hover {
            background: rgb(255 255 255 / 0.05);
          }
        `
      : css`
          background: ${Colors.Color4};
          color: white;

          &:hover {
            background: ${Colors.Color31};
          }
        `}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const WarningText = styled.p`
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${Colors.text_Color_1};
  line-height: 1.4;
  font-size: 0.6em;
  font-weight: 300;
  max-width: 250px;

  i {
    font-size: 14px;
    color: ${Colors.text_Color_1};
  }
`;
